import React, { useEffect, useState } from "react";
import {
  baseUrl,
  fetchConversation,
  fetchConversationOpened,
  fetchTestauthorize,
  getCurrentUser,
  setCurrentUser,
} from "./api/chatApi";
import "./App.css";
import ConversationComponent from "./Components/Conversation/ConversationComponent";
import Navbar from "./Components/LeftNavBar/Navbar";
import ChoosePersonsModal from "./Components/Sidebar/ChoosePersonsModal";
import Sidebar from "./Components/Sidebar/Sidebar";
import Tutorial from "./Components/VideoTutorial/Tutorial";
import "./Updates.scss";
import { HubConnectionBuilder } from "@microsoft/signalr";
import i18n from "./i18n";
import { timeout } from "./helpers/utilities";

const environment = "PROD";
const test_personId = 89541;
const test_version = 2;

function App() {
  const [mode, setMode] = useState("classic");
  const [user, setUser] = useState(null);
  const [connection, setConnection] = useState(null);
  const [newMessage, setNewMessage] = useState(null);
  const [newSeenMessage, setNewSeenMessage] = useState(null);
  const [currentUrlQueryString, setCurrentQueryString] = useState("");

  const toggleMode = () => {
    let newMode = mode === "classic" ? "dark-mode" : "classic";
    setMode(newMode);
    localStorage.setItem("modeType", newMode);
  };

  //Conversation
  const [isLoadingConversation, setLoadingConversation] = useState(false);
  const [Conversation, setConversation] = useState([]);
  const [scrolltop, setScrolltop] = useState(false);
  const [oponentId, setOponentId] = useState(null);
  const [isgroup, setIsgroup] = useState(false);
  const [avatar, setAvatar] = useState(null);
  const [oponentName, setOponentName] = useState("");
  const [loadMore, setLoadMore] = useState(false);

  const [selectedContact, setSelectedContact] = useState(null);

  const [newGroupName, setNewGroupName] = useState("");
  const selectedContactNameChange = (newName) => {
    setNewGroupName(newName);
  };

  const getConversationContent = (oponentId, isgroup, scroll, name, avatar) => {
    setSelectedContact(oponentId);
    if (!scroll) fetchConversationOpened(oponentId, isgroup);
    setLoadingConversation(true);
    setOponentId(oponentId);
    if (name) setOponentName(name);
    setIsgroup(isgroup);
    setAvatar(avatar);
    setScrolltop(scroll);
    if (!scroll) setConversation([]);
    fetchConversation({
      oponentId,
      isgroup,
      skip: !scroll ? 0 : Conversation.length,
    }).then((res) => {
      setLoadMore(res.length > 49);
      res.reverse();
      for (let c of res) {
        if (!c.messageSeenDate && c.senderId !== user.id) c.messageSeenDate = new Date().getTime();
      }
      if (!scroll) setConversation(res);
      else setConversation([...res, ...Conversation]);
      setLoadingConversation(false);
    });
  };

  const fetchCurrentUser = async () => {
    try {
      let user = await getCurrentUser();
      setUser(user);
      setCurrentUser(user);
      i18n.changeLanguage(user.language === "ge" ? "ka" : "en-US");
      if (user.opponent) {
        //await timeout(100);
        //alert(user.opponent);
        getConversationContent(user.opponent, false, false, null, null);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const init = () => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(baseUrl + "/message") //, (options) => options.Headers)
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);

    let lMode = localStorage.getItem("modeType");
    if (!lMode) {
      lMode = "classic";
      localStorage.setItem("modeType", lMode);
    } else setMode(lMode);
    fetchCurrentUser();
  };

  const authorizeTest = async () => {
    let res = await fetchTestauthorize(test_personId, test_version);
    if (res) init();
  };

  useEffect(() => {
    if (environment === "TEST") authorizeTest();
    else init();
  }, []);

  //Goback btn - on md/sm/xs devices leave conversation detail
  const leaveConversation = () => {
    setOponentId(undefined);
    setSelectedContact(undefined);
    setConversation([]);
  };

  const [modalIsOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
  };

  const [openConversationItem, setOpenConversationItem] = useState(null);
  const closeModal = (item, isGroup) => {
    setIsOpen(false);
    if (item) {
      setOpenConversationItem({
        id: item.id,
        name: item.name || item.fullName,
        isGroup,
        avatar: item.avatar,
      });
      getConversationContent(item.id, isGroup, false, item.name || item.fullName, item.avatar);
    }
  };

  useEffect(() => {
    if (
      newMessage &&
      ((user.id === newMessage.senderId && !newMessage.isGroup) ||
        (oponentId === newMessage.senderId && isgroup === newMessage.isGroup))
    ) {
      if (user.id !== newMessage.senderId) {
        fetchConversationOpened(newMessage.senderId, newMessage.isGroup);
        newMessage.messageSeenDate = newMessage.messageSendDate;
      }
      setConversation([...Conversation, newMessage]);
    }
  }, [newMessage]);

  const deleteGroup = (id) => {
    setOponentId(undefined);
    setSelectedContact(undefined);
  };

  useEffect(() => {
    if (newSeenMessage) {
      if (!isgroup && oponentId === newSeenMessage.opponentId && Conversation && Conversation.length > 0) {
        for (let val of Conversation) {
          if (!val.messageSeenDate) val.messageSeenDate = newSeenMessage.seenTime;
        }
        setConversation([...Conversation]);
      }
    }
  }, [newSeenMessage]);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then((result) => {
          console.log("Connected!");

          connection.on("ReceiveMessage", (message) => {
            console.log(message);
            setNewMessage(message);
          });

          connection.on("ReceiveSeenStatus", (message) => {
            console.log(message);
            setNewSeenMessage(message);
          });
        })
        .catch((e) => console.log("Connection failed: ", e));
    }
  }, [connection]);

  const [videoModal, setVideoModal] = useState(false);
  const openVideoModal = () => {
    setVideoModal(true);
  };

  const closeVideoModal = () => {
    setVideoModal(false);
  };

  useEffect(() => {
    let locationUrl = window.location.href;
    let queryString = locationUrl.substring(locationUrl.indexOf("?") + 1);
    console.log(locationUrl);
    if (queryString) {
      setCurrentQueryString(queryString);
    }
  }, []);

  return user ? (
    <>
      <div className={currentUrlQueryString.includes("ismobile=true") ? "App h-100 isMobileApp" : "App h-100 "}>
        <div className={`main-layout ${mode === "classic" ? "classic-mode" : "dark-mode "}`}>
          <Navbar toggleMode={toggleMode} activeMode={mode} user={user} openVideoModal={openVideoModal} />

          <Sidebar
            getConversationContent={getConversationContent}
            selectedContact={selectedContact}
            openConversationModal={openModal}
            openConversationItem={openConversationItem}
            user={user}
            newMessage={newMessage}
            newGroupName={newGroupName}
          />
          <ConversationComponent
            isLoading={isLoadingConversation}
            Conversation={Conversation}
            scrolltop={scrolltop}
            leaveConversation={leaveConversation}
            getConversationContent={getConversationContent}
            oponentId={oponentId}
            isgroup={isgroup}
            loadMore={loadMore}
            openConversationModal={openModal}
            oponentName={oponentName}
            user={user}
            newMessage={newMessage}
            avatar={avatar}
            deleteGroupHandler={deleteGroup}
            selectedContactNameChangeHandler={selectedContactNameChange}
          />

          {/* <Toolbar  /> */}
        </div>
      </div>
      {modalIsOpen && <ChoosePersonsModal closeModal={closeModal} user={user} />}

      {videoModal && <Tutorial closeVideoModal={closeVideoModal} />}
    </>
  ) : null;
}

export default App;
